module.exports = __webpack_public_path__ + "static/img/xd.54086a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/xd.png
// module id = AFBh
// module chunks = 1